exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sn-login-title {\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n}\r\n\r\n.error_msg {\r\n    color: red;\r\n    text-align: center;\r\n    padding: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/login/login.component.css
// module id = ../../../../../src/app/components/login/login.component.css
// module chunks = main